import React from "react";
import { InputText } from "primereact/inputtext";
import styles from "./index.module.css";

interface InputTextProps {
    label: string;
    value: string | null;
    onChange: (value: string | null) => void;
    isDisabled: boolean;
    placeholder?: string;
}

const RenderInputText: React.FC<InputTextProps> = ({
    label,
    value,
    onChange,
    isDisabled,
    placeholder
}): JSX.Element => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const newValue = e.target.value ? e.target.value : null;
        onChange(newValue);
    };

    return (
        <div className={styles.filterItem}>
            <label className={styles.filterLabel}>{label}:</label>
            <InputText
                value={value ?? ""}
                onChange={handleChange}
                disabled={isDisabled}
                placeholder={placeholder}
                className={`${styles.inputText} ${styles.inputTextChart}`}
            />
        </div>
    );
};

export default RenderInputText;
